module.exports = __webpack_public_path__ + "img/ao.c862bf60.svg";